export default "__VITE_ASSET__CbWbAeJ2__"